import { IGetAllProjetoRevisaoUseCase } from "../../../presentation/useCases/read/get_all_projeto_revisao_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";

import { IProjetosRepository } from "../../repositories/projetos_repository";
import { GetAllProjetoRevisaoDao } from "../../../data/daos/read/get_all_projeto_revisao";

/**
 * GetAllProjetoRevisaoUseCase
 */

export class GetAllProjetoRevisaoUseCase extends BasePaginatedUseCase<GetAllProjetoRevisaoDao> implements IGetAllProjetoRevisaoUseCase {
  constructor(private readonly repository: IProjetosRepository) {
    super();
  }

  async execute(
    idsProjeto?: number[],
    idsCentrocusto?: number[],
    idsSolicitante?: number[],
    status?: number[],
    dataDe?: Date,
    dataAte?: Date,

    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const response = await this.repository.getAllProjetoRevisao(
      idsProjeto,
      idsCentrocusto,
      idsSolicitante,
      status,
      dataDe,
      dataAte,
      currentPage,
      rowsPerPage,
    );

    this._items = response.items;
    this._totalPages = response.totalPages;
    this._totalItems = response.totalItems;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}
